import { AppBox, AppTitle } from "../../../commons/components";
import { useAppSelector } from "../../../hooks/app";
import { ISelectOptions } from "../../../commons/components/ui-components/Select";
import { MatchStatisticsEventEnum } from "../../../commons/enums/match-statistics-event-enum";
import { MatchStatisticsAdd } from "./components/statistics/MatchStatisticsAdd";
import MatchStatisticsList from "./components/statistics/MatchStatisticsList";
import { useState } from "react";
import ability, { Can } from "../../../casl/Can";
import { RolePolicyActionEnum } from "../../../commons/enums/role-policy-action.enum";
import { ManageFootballTeam } from "../../../commons/models/football/admin/manage-football-team";
import { useParams } from "react-router";
import {ManageFootballCompetition} from "../../../commons/models/football/admin/manage-football-competition";

export const statisticsEventsOption: ISelectOptions[] = [
  { title: "Possession", value: MatchStatisticsEventEnum.Possession },
  { title: "Passes", value: MatchStatisticsEventEnum.Passes },
  { title: "Interception", value: MatchStatisticsEventEnum.Interception },
];

const MatchDetailManageStatistics = () => {
  const { seasonMatchDetail } = useAppSelector((state) => state.footballManageSeasonMatchDetail);
  const { teamId } = useParams();
  const [selectedStatisticEvent, setSelectedStatisticEvent] = useState<string>(MatchStatisticsEventEnum.Possession);
  return (
    <AppBox mb="sm" flexDirection="column" gap="sm">
      <AppBox flexDirection="column" gap="xs">
        {(ability.can(RolePolicyActionEnum.UPDATE, new ManageFootballCompetition(seasonMatchDetail.competition)) ||
          ability.can(RolePolicyActionEnum.UPDATE, new ManageFootballTeam({ id: Number(teamId) }))) && (
          <>
            <AppTitle as="h5">Add Statistics</AppTitle>
            <MatchStatisticsAdd
              match={seasonMatchDetail}
              onSelectedEvent={(event) => {
                setSelectedStatisticEvent(event);
              }}
              statisticMatchEvent={selectedStatisticEvent}
            />
          </>
        )}
      </AppBox>
      <MatchStatisticsList
        match={seasonMatchDetail}
        statisticMatchEvent={selectedStatisticEvent}
        onSelectedEvent={(event) => {
          setSelectedStatisticEvent(event);
        }}
      />
    </AppBox>
  );
};

export default MatchDetailManageStatistics;
